import React from 'react';
import PropTypes from 'prop-types';
import HouseholdSectionPicker
  from 'Components/Flyouts/HouseholdInfo/Sections/Section/HouseholdSectionPicker/HouseholdSectionPicker';
import HouseholdSectionServicePicker from './HouseholdSectionServicePicker/HouseholdSectionServicePicker';

const ServiceSection = ({ householdResource }) => {
  return (
    <HouseholdSectionPicker label="Service" resource={householdResource}>
      <HouseholdSectionServicePicker resource={householdResource} />
    </HouseholdSectionPicker>
  );
};

ServiceSection.propTypes = {
  householdResource: PropTypes.object.isRequired,
};

export default ServiceSection;
